import {
  advisoryRemoveCriteria,
  advisoryStoreCriteria,
  appModalOpen,
} from 'actions';
import { connect } from 'react-redux';
import View from './';

const mapStateToProps = state => ({
  advisory: state.advisory,
  intl: state.intl,
  modals: state.app.modals,
});
const mapDispatchToProps = (dispatch) => {
  return {
    advisoryRemoveCriteria(payload) {
      dispatch(advisoryRemoveCriteria(payload));
    },
    advisoryStoreCriteria(payload) {
      dispatch(advisoryStoreCriteria(payload));
    },
    appModalOpen(payload) {
      dispatch(appModalOpen(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/advisory-tool/detail/container.js